import { trackVideo } from "../../feature/Analytics/ga/contentStream";
import { MOVING_IMAGE_COOKIE_CONSENT_GROUP } from "../constants";

class VideoManager {
  private tracked = false;
  private loaded = false;
  private playerConfig: any;
  private elementId: string;

  constructor(videoUrl: string, elementId: string) {
    const params = new URLSearchParams(videoUrl.split("?")[1]);
    const videoId = params.get("video-id");
    const playerId = params.get("player-id");
    const channelId = params.get("channel-id");

    this.elementId = elementId;

    this.playerConfig = {
      success: (playerApi: any) => {
        playerApi.registerEventListener("playing", () => {
          if (!this.tracked) {
            trackVideo(videoId!);
          }
          this.tracked = true;
        });
      },
      parameters: {
        configType: "vmpro",
        playerId: playerId,
        channelId: channelId,
        videoId: videoId,
        apiUrl: "//d-mi.schaeffler-cdn.com/play",
        flashPath: "//e-mi.schaeffler-cdn.com/v2/",
      },
    };
  }

  load = () => {
    if (!this.loaded && document.getElementById(this.elementId)) {
      // @ts-ignore
      window.VideoPlayer.Collection.addPlayerById(this.elementId, this.playerConfig);
      this.loaded = true;
    }
  };

  unload = () => {
    if (this.loaded && document.getElementById(this.elementId)) {
      // @ts-ignore
      window.VideoPlayer.Collection.removePlayerById(this.elementId);
      this.loaded = false;
    }
  };

  reset = () => {
    this.unload();
    this.load();
  };

  getElementId = () => this.elementId;
}

const apiLoaded = false;
let apiLoading = false;
const videos: VideoManager[] = [];

export function addVideo(elementId: string, videoUrl: string) {
  const videoManager = new VideoManager(videoUrl, elementId);
  videos.push(videoManager);

  if (!apiLoaded && !apiLoading) {
    apiLoading = true;
    loadApi().then(() => {
      apiLoading = false;
      updateCookieConsent();
      videos.forEach((video) => video.load());
    });
  }
}

export function removeVideo(elementId: string) {
  const index = videos.map((video) => video.getElementId()).indexOf(elementId);
  const video = videos.splice(index, 1)[0];
  video?.unload();
}

function loadApi() {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.setAttribute("src", "https://e.video-cdn.net/v2/embed.js");
    script.onload = resolve;
    document.body.appendChild(script);
  });
}

let lastConsent = false;
function updateCookieConsent() {
  // @ts-ignore
  const newConsent = window.OnetrustActiveGroups?.includes(MOVING_IMAGE_COOKIE_CONSENT_GROUP) ?? false;

  if (newConsent) {
    // @ts-ignore
    window.VideoPlayer?.Collection.acceptAnalytics();
  } else {
    // @ts-ignore
    window.VideoPlayer?.Collection.rejectAnalytics();
  }

  if (lastConsent !== newConsent) {
    lastConsent = newConsent;
    return true;
  }
  return false;
}

// @ts-ignore
window.updateMICookieConsent = () => {
  if (updateCookieConsent()) {
    videos.forEach((video) => video.reset());
  }
};
